import React, { useState } from "react";
import Modal from "../../../common/Modal/Modal";
import "../../../common/Modal/Modal.css";

const orgs = [
  {
    name: "NL BED Manufacturing",
    location: "Netherlands",
    type: "Manufacturing",
    status: "ACTIVE",
    created: "2025-01-15",
  },
];

export default function OrganizationConfiguration() {
  const [showOrgConfigModal, setShowOrgConfigModal] = useState(false);
  const [orgConfigForm, setOrgConfigForm] = useState({
    name: "",
    desacription: "",
    location: "",
    domain: "",
  });

  const { OrganizationMgmt } = JSON.parse(
    sessionStorage.getItem("rolesAndPermission") || "{}"
  );
  return (
    <div className="rounded-2xl bg-white p-6 shadow-md mt-6">
      <h2 className="text-3xl font-bold mb-6">Organization Configuration</h2>
      {OrganizationMgmt.canAdd && (
        <div className="flex justify-end mb-4">
          <button className="bg-blue-700 text-white px-6 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-800" onClick={() => setShowOrgConfigModal(true)}>
            <span className="text-xl font-bold">+</span> Add Organization
          </button>
        </div>
      )}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white rounded-lg">
          <thead>
            <tr className="border-b">
              <th className="py-3 px-4 text-left font-semibold">
                Organization Name
              </th>
              <th className="py-3 px-4 text-left font-semibold">Location</th>
              <th className="py-3 px-4 text-left font-semibold">Domain</th>
              <th className="py-3 px-4 text-left font-semibold">Status</th>
              <th className="py-3 px-4 text-left font-semibold">
                Created Date
              </th>
              {(OrganizationMgmt.canUpdate || OrganizationMgmt.canDelete) && (
                <th className="py-3 px-4 text-left font-semibold">Actions</th>
              )}
            </tr>
          </thead>
          <tbody>
            {orgs.map((org, idx) => (
              <tr key={idx} className="border-b hover:bg-gray-50">
                <td className="py-2 px-4">{org.name}</td>
                <td className="py-2 px-4">{org.location}</td>
                <td className="py-2 px-4">{org.type}</td>
                <td className="py-2 px-4">
                  <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-bold">
                    {org.status}
                  </span>
                </td>
                <td className="py-2 px-4">{org.created}</td>
                {(OrganizationMgmt.canUpdate || OrganizationMgmt.canDelete) && (
                  <td className="py-2 px-4 flex gap-2">
                    {OrganizationMgmt.canUpdate && (
                      <span className="cursor-pointer" title="Edit">
                        ✏️
                      </span>
                    )}
                    {OrganizationMgmt.canDelete && (
                      <span className="cursor-pointer" title="Delete">
                        🗑️
                      </span>
                    )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Modal
        show={showOrgConfigModal}
        title="Add Organization"
        setShowModal={setShowOrgConfigModal}
      >
        <form
          className="modal-body"
          onSubmit={(e) => {
            e.preventDefault();
            setShowOrgConfigModal(false);
          }}
        >
          <div className="modal-field">
            <label>Organization Name</label>
            <input
              type="text"
              value={orgConfigForm.name}
              onChange={(e) =>
                setOrgConfigForm((f) => ({ ...f, name: e.target.value }))
              }
            />
          </div>
          <div className="modal-field">
            <label>Organization Description</label>
            <input
              type="text"
              value={orgConfigForm.desacription}
              onChange={(e) =>
                setOrgConfigForm((f) => ({ ...f, desacription: e.target.value }))
              }
            />
          </div>
          <div className="modal-field">
            <label>Location</label>
            <input
              type="text"
              value={orgConfigForm.location}
              onChange={(e) =>
                setOrgConfigForm((f) => ({ ...f, location: e.target.value }))
              }
            />
          </div>
          <div className="modal-field">
            <label>Domain</label>
            <input
              type="text"
              value={orgConfigForm.domain}
              onChange={(e) =>
                setOrgConfigForm((f) => ({ ...f, domain: e.target.value }))
              }
            />
          </div>
          <div className="modal-actions">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => setShowOrgConfigModal(false)}
            >
              Cancel
            </button>
            <button type="submit" className="submit-btn">
              Save
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
